/**
 * @param {String} field
 */
export function existsOrIsEmpty(field) {
    return !!field || field === '';
}
/**
 * Add the fullName field to a member based on the fields
 *
 * @param {Object} member
 *
 * @returns {Object}
 */
export function addFullName(member) {
    return {
        ...member,
        fullName: member.fields.firstName ? [member.fields.firstName, member.fields.lastName].filter(Boolean).join(' ') : member.email,
    };
}
/**
 * Create a new member model with the supplied details.
 *
 * @param {String} email - The email for the member (required)
 * @param {String} firstName - The members first name (optional)
 * @param {String} lastName - The members last name (optional)
 * @param {String} role - The members job role (optional)
 * @param {String} company - The members company name (optional)
 * @param {String} linkedin
 * @param {String} bio
 * @param {String} labels
 * @param {String} url
 *
 * @returns {Object}
 */
export function formatFieldsToMember({ email, firstName, lastName, role, company, linkedin, bio, labels, url }) {
    return {
        email: email.toLowerCase(),
        ...(existsOrIsEmpty(firstName) && { firstName }),
        ...(existsOrIsEmpty(lastName) && { lastName }),
        ...(existsOrIsEmpty(role) && { role }),
        ...(existsOrIsEmpty(company) && { company }),
        ...(existsOrIsEmpty(linkedin) && { linkedin }),
        ...(existsOrIsEmpty(bio) && { bio }),
        ...(existsOrIsEmpty(labels) && { labels }),
        ...(existsOrIsEmpty(url) && { url }),
    };
}
/**
 * Create a new member model with the supplied details.
 *
 * @param {String} email - The email for the member (required)
 * @param {String} workspaceId - The workspace ID to belong to (optional)
 * @param {String} firstName - The members first name (optional)
 * @param {String} lastName - The members last name (optional)
 * @param {String} role - The members job role (optional)
 * @param {String} company - The members company name (optional)
 * @param {String} linkedin
 * @param {String} bio
 * @param {String} labels
 * @param {String} url
 *
 * @returns {Object}
 */
export function formatMemberUpdateObject({ workspaceId, email, firstName, lastName, role, company, linkedin, bio, labels, url, integrations, }) {
    return {
        email: email.toLowerCase(),
        ...(workspaceId && { workspace_id: workspaceId }),
        ...(existsOrIsEmpty(firstName) && {
            'fields.first_name': firstName,
        }),
        ...(existsOrIsEmpty(lastName) && {
            'fields.last_name': lastName,
        }),
        ...(existsOrIsEmpty(role) && { 'fields.role': role }),
        ...(existsOrIsEmpty(company) && { 'fields.company': company }),
        ...(existsOrIsEmpty(linkedin) && { 'fields.linkedin': linkedin }),
        ...(existsOrIsEmpty(bio) && { 'fields.bio': bio }),
        ...(existsOrIsEmpty(labels) && { 'fields.labels': labels }),
        ...(existsOrIsEmpty(url) && { 'fields.url': url }),
        integrations,
    };
}
